import { cn } from '@teable/ui-lib/shadcn';
import Image from 'next/image';
import { useBrand } from '@/features/app/hooks/useBrand';

// Krossings "K" mark (from the Krossings brand kit), used as the Content Hub logo. A custom uploaded
// brandLogo (admin branding setting) overrides it. No Teable branding is rendered.
const KrossingsMark = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 118.5 79.3"
    fill="#276fff"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={cn('h-6 w-auto', className)}
  >
    <rect x="49.4" y="1" width="19.7" height="77.3" />
    <polygon points="86.1 39.6 118.5 1 95.8 1 63.8 40.1 95.8 78.3 118.5 78.3 86.1 39.6" />
    <polygon points="32.4 39.6 0 78.3 22.7 78.3 54.7 39.2 22.7 1 0 1 32.4 39.6" />
  </svg>
);

export const TeableLogo = ({ className }: { className: string }) => {
  const { brandName, brandLogo } = useBrand();

  if (brandLogo) {
    return (
      <Image src={brandLogo} alt={brandName} width={64} height={64} className={cn('size-6', className)} />
    );
  }

  return <KrossingsMark className={className} />;
};
